import React, { useEffect, useState } from "react";

// import app from "@/store/app";
import { dateToMonth } from "../../lib/utils";
import { Tooltip } from "../ui/tooltip";

const cancel_types = {
  prepaid: "от размера предоплаты",
  booking: "от стоимости бронирования",
  first_day: "от стоимости первых суток",
};

function PrintTariffPaymentConditions({ tariff }) {
  const [freeCancelDate, setFreeCancelDate] = useState("");

  // useEffect(() => {
  //   if (
  //     tariff?.cancel_reservation_fee === "yes" &&
  //     tariff?.cancel_reservation_fee_time === "from_time"
  //   ) {
  //     // проверка что текущая дата меньше равно дате бесплатной отмены
  //     const free_cancel_date = dateMinusDays(
  //       app.dateCheckin,
  //       tariff?.cancel_reservation_activation_time || 0,
  //     );
  //     if (new Date() <= new Date(free_cancel_date))
  //       setFreeCancelDate(free_cancel_date);
  //   }
  // }, []);

  return (
    <div className="dfsp dfa">
      <div>
        <span>
          {!tariff?.terms_of_payment || tariff?.terms_of_payment === "checkin"
            ? "Оплата при заселении"
            : `Требуется предоплата ${tariff?.terms_of_payment_prepaid_sum}${
                tariff?.terms_of_payment_prepaid_type ? "₽" : "%"
              }`}
        </span>
        <br />
        <span>
          {!tariff?.cancel_reservation_fee ||
            (tariff?.cancel_reservation_fee === "no" && (
              <span className="green">Бесплатная отмена</span>
            ))}
          {freeCancelDate && (
            <span className="green">
              Бесплатная отмена до {dateToMonth(freeCancelDate, true)}
            </span>
          )}
          {!freeCancelDate && tariff?.cancel_reservation_fee === "yes" && (
            <span className="extraRed">При отмене удерживается штраф</span>
          )}
        </span>
      </div>
      {tariff?.cancel_reservation_fee === "yes" && (
        <div style={{ marginLeft: "5px" }}>
          <Tooltip>
            <span>
              {tariff?.cancel_reservation_fee_amount_type === 0 &&
              tariff?.cancel_reservation_fee_amount === 100 &&
              tariff?.cancel_reservation_type !== "first_day" ? (
                <>При отмене оплата не возвращается</>
              ) : (
                <>
                  Штраф за отмену {tariff?.cancel_reservation_fee_amount}
                  {tariff?.cancel_reservation_fee_amount_type ? "₽" : "%"}
                  {/* если % */}
                  {tariff?.cancel_reservation_fee_amount_type === 0 && (
                    <> {cancel_types[tariff?.cancel_reservation_type]}</>
                  )}
                </>
              )}
            </span>
            <br />
            {freeCancelDate && (
              <span className="green">
                Бесплатная отмена до {dateToMonth(freeCancelDate)}
              </span>
            )}
          </Tooltip>
        </div>
      )}
    </div>
  );
}

export default PrintTariffPaymentConditions;
